import React, { useEffect, useState } from 'react';
import { API } from 'aws-amplify';
import SensorTimelineChart from "./SensorTimelineChart";

const params = {
  headers: {
    'x-api-key': process.env.REACT_APP_API_KEY,
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
};

const RadarConnection = () => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const fetchAssets = async () => {
      try {
        const connection = await API.get('assets_connections', '/', params);

        // Transform data to match expected structure
        const transformed = connection.map(item => ({
          asset_id: { S: item.asset_id },
          history: {
            L: item.history.map(date => ({ S: date }))
          },
          status: { BOOL: item.status }
        }));

        setChartData(transformed);
      } catch (error) {
        console.error('Error fetching asset connections:', error);
      }
    };

    fetchAssets();
  }, []);

  const TOP_N = 15;
  const ROW_HEIGHT = 400000;


return (
  <div
    className="DeviceMap"
    style={{
      maxWidth: "100%",
      margin: "auto",
      padding: "2rem",
    }}
  >
    <SensorTimelineChart
      data={chartData.slice(0, TOP_N)}  // Show only top N
      height={TOP_N * ROW_HEIGHT}
      rowHeight={ROW_HEIGHT}
    />
  </div>
);
};

export default RadarConnection;
